<template>
    <v-container>
        <loading-spinner v-if="loading"/>
        <div v-else>
            <back-button fixed/>
            <routine-detail :routine="currentRoutine" @selectRoutine="onSelectRoutine"/>
            <assign-routine-dialog ref="assign" :routine-id="routineId" :coach-id="coachId" />
        </div>
    </v-container>
</template>

<script>

import RoutineDetail from '@/components/coach/routines/RoutineDetail'
import {db} from '@/utils/Firebase'
import {mapState, mapMutations} from 'vuex'
import {getMergedBlocks} from "@/utils/Exercises";
import LoadingSpinner from "@/components/common/LoadingSpinner";
import BackButton from "@/components/common/BackButton";
import AssignRoutineDialog from '../../components/coach/routines/AssignRoutineDialog.vue';

export default {
    components: {BackButton, LoadingSpinner, RoutineDetail, AssignRoutineDialog},
    data() {
        return {
            loading: false,
            routine: null,
        }
    },
    computed: {
        ...mapState(['currentRoutine']),
        routineId(vm = this) {
            return vm.$route.params.uid
        },
        coachId(vm = this) {
            return vm.currentUser.uid
        }
    },
    methods: {
        ...mapMutations(['setCurrentRoutine']),
        async setRoutine() {
            const vm = this
            vm.loading = true
            let routineRef = await db.collection('routines').doc(vm.routineId).get()
            vm.routine = routineRef.data()
            vm.routine.blocks = await getMergedBlocks(vm.routine.blocks)
            vm.setCurrentRoutine(vm.routine)
            vm.loading = false
        },
        onSelectRoutine() {
            const vm = this
            vm.$refs.assign.show()
        },
    },
    mounted() {
        const vm = this
        vm.setRoutine()
    },
    beforeRouteLeave(to, from, next) {
        const vm = this
        if (to.name !== 'student.routine.detail.exercise' && !vm.dialogActive) vm.setCurrentRoutine(null)
        next()
    }
}
</script>

<style scoped>

</style>